import { CampusConstants as Constants } from '../types'

const initialState = {
    campuses: [],    
    error: null,    
    loading: false   
};

export function campusReducer(state = initialState, action) {
    switch (action.type) {  
        case Constants.GET:                     
            return {
                ...state,
                campuses: action?.payload?.campuses,
                loading: false,
                error: null,
            };

   
            
        case Constants.ADD:
            return {
                ...state,
                campuses: [...state?.campuses, action?.payload?.campus],
                loading: false,
                error: null,
            }

        case Constants.UPDATE:            
            const index = state.campuses.findIndex(x => x.id ===  action?.payload?.campus?.id)
            const newArray = [...state.campuses];
            if(index > -1)
                newArray[index] = action?.payload?.campus
            return {
                ...state,
                campuses: newArray,
                loading: false,
                error: null,
            }   

        case Constants.DELETE:
            return{
                ...state,
                campuses: state?.campuses?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id)),
                loading: false,
                error: null,
            };

        case Constants.REMOVE_DOC:
            const campus_index = state.campuses.findIndex(x => parseInt(x.id) ===  parseInt(action?.payload?.campus_id))            
            const all_campuses = [...state.campuses];
            if(campus_index > -1){
                const campus = all_campuses[campus_index]
                let docs = campus?.documents?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.doc_id))
                campus['documents'] = docs;
                all_campuses[campus_index] = campus
            }
            
            return{
                ...state,
                campuses: all_campuses,
                loading: false,
                error: null,
            };
       
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error,
                loading: false
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null,
                loading: true
            }

        case Constants.CLEAR:
        default:
            return state
    }
}